<template>
  <FormModal header="Create new list" :name="name">
    <FormModalBody
      footer-button-text="Save"
      @submit="createList"
      :is-button-loading="form.processing"
    >
      <FormInput
        v-model="form.name"
        :is-error="Boolean(form.errors.name)"
        :errors="form.errors.name"
        @input="form.clearErrors('name')"
        is-required
        type="text"
        test_id="create-new-list-name-input"
      >
        <template #label>List name</template>
      </FormInput>
      <FormInput
        as="textarea"
        rows="5"
        v-model="form.description"
        :is-error="Boolean(form.errors.description)"
        :errors="form.errors.description"
        @input="form.clearErrors('description')"
        class="tw-mt-4"
        test_id="create-new-list-description-input"
      >
        <template #label>Description</template>
      </FormInput>
    </FormModalBody>
  </FormModal>
</template>

<script setup>
import FormModal from '@/shared/components/modals/FormModal/FormModal.vue'
import FormModalBody from '@/shared/components/modals/FormModal/FormModalBody.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'
import { useForm } from '@inertiajs/vue3'
import { useModals } from '@/shared/composables/useModals.js'

const emit = defineEmits(['success'])

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  mentorId: {
    type: Number,
    default: null,
  },
})

const { closeModal } = useModals()
const form = useForm({
  name: '',
  description: '',
})

const createList = () => {
  form
    .transform((data) => ({
      list: data,
      // If mentorId is passed, then this user will be automatically added to the list
      ...(props.mentorId ? { mentor_id: props.mentorId } : {}),
    }))
    .post('/lists', {
      preserveScroll: true,
      onSuccess: () => {
        form.reset()
        closeModal(props.name)
        emit('success')
      },
    })
}
</script>
